import { OtherConfigurations } from './other-configurations'
import { Orientation } from './property'
import { RoomConfigurations } from './room-configurations'
import { UnitAddress } from './unit-address'

export enum UnitType {
  RESIDENTIAL = 'RESIDENTIAL',
  COMMERCIAL = 'COMMERCIAL',
}

export type Unit = {
  id?: string
  type?: UnitType
  uniqueKey?: string
  propertyId: string
  buildingId: string
  address: UnitAddress
  squareFootage: number
  floorLevel: number
  orientation?: Orientation
  roomConfigurations: RoomConfigurations
  otherConfigurations: OtherConfigurations
}
